// extracted by mini-css-extract-plugin
export default {"eventCard":"EventCardContainer-module__eventCard___2zNB0"};